import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Portofoliu() {
  const IMAGINI = [1, 2, 3, 4, 5, 6].map((n) => `/images/portofoliu/${n}.png`);

  return (
    <section>
      <PageHero
        title="Portofoliu"
        subtitle="Selecție de lucrări realizate în atelier."
      />
      <p className="mb-6">
        Descoperă o parte dintre creațiile noastre — fiecare rochie este realizată la comandă, pe măsuri.
      </p>

      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
